function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "actively_looking",
  transform: "translate(-1200.496 -840)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_5639",
  width: 56,
  height: 56,
  transform: "translate(1200.496 840)",
  fill: "none"
}), /*#__PURE__*/React.createElement("g", {
  id: "binoculars",
  transform: "translate(1200.497 837.81)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_3236",
  cx: 8.19,
  cy: 8.19,
  r: 8.19,
  transform: "translate(17.311 21.272) rotate(-22.362)",
  fill: "#000072"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_3237",
  cx: 12,
  cy: 12,
  r: 12,
  transform: "translate(0.646 18.192)",
  fill: "#000072"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_3238",
  cx: 12,
  cy: 12,
  r: 12,
  transform: "translate(31.349 18.192)",
  fill: "#000072"
}), /*#__PURE__*/React.createElement("path", {
  id: "Union_146",
  d: "M30.694,10.28a10.282,10.282,0,1,1,10.28,10.281A10.292,10.292,0,0,1,30.694,10.28ZM0,10.28A10.281,10.281,0,1,1,10.28,20.562,10.293,10.293,0,0,1,0,10.28Z",
  transform: "translate(2.371 19.911)",
  fill: "#ff0660"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_60733",
  d: "M13.329,38.787a7.919,7.919,0,1,1,7.91-7.919A7.928,7.928,0,0,1,13.329,38.787Z",
  transform: "translate(-0.676 -0.677)",
  fill: "#000072",
  opacity: 0.24
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_60734",
  d: "M9.61,27.525A1.435,1.435,0,1,1,8.175,26.09,1.436,1.436,0,0,1,9.61,27.525Z",
  transform: "translate(-0.843 -1.069)",
  fill: "#ff0660"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_60736",
  d: "M48.409,38.787a7.919,7.919,0,1,1,7.919-7.919A7.928,7.928,0,0,1,48.409,38.787Z",
  transform: "translate(-5.062 -0.677)",
  fill: "#000072",
  opacity: 0.24
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_3239",
  cx: 1.435,
  cy: 1.435,
  r: 1.435,
  transform: "translate(36.592 25.021)",
  fill: "#ff0660"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_3329",
  cx: 4.425,
  cy: 4.425,
  r: 4.425,
  transform: "translate(22.225 23.278) rotate(-22.362)",
  fill: "#ffe5ef"
})));

function SvgActivelyLooking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivelyLooking);
export default __webpack_public_path__ + "static/media/actively_looking.59074a47.svg";
export { ForwardRef as ReactComponent };